// extracted by mini-css-extract-plugin
module.exports = {"totalCash":"TotalCashSection_totalCash__r0w2o","totalCashDescription":"TotalCashSection_totalCashDescription__32tyZ"};